import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { TaskPriorityResponse } from '../models/task.model';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';

export interface TaskPriorityDrawerOptions { priorityId?: number; }

@Injectable({ providedIn: 'root' })
export class TaskPriorityDrawerService {
  private readonly registry = inject(DrawerRegistryService);
  private readonly state$ = new BehaviorSubject<{ isOpen: boolean; options: TaskPriorityDrawerOptions }>({
    isOpen: false, options: {}
  });
  private readonly saved$$ = new Subject<TaskPriorityResponse>();

  readonly state = this.state$.asObservable();
  readonly saved$ = this.saved$$.asObservable();

  open(options: TaskPriorityDrawerOptions = {}): void {
    if (!this.state$.value.isOpen) this.registry.opened();
    this.state$.next({ isOpen: true, options });
  }

  close(): void {
    if (this.state$.value.isOpen) this.registry.closed();
    this.state$.next({ isOpen: false, options: {} });
  }
  notifySaved(item: TaskPriorityResponse): void { this.saved$$.next(item); }
}
